






















































import { Emit, Inject, Prop, VModel, Vue, Watch } from "vue-property-decorator";
import Component from "vue-class-component";
import FileGeodeticService from "@/entities/file-geodetic/file-geodetic.service";

@Component
export default class FileFlightDateChangeDialog extends Vue {
  @Prop() file;

  @VModel({ type: Boolean }) dialog: boolean;
  @Inject() refreshPage: () => void;

  flightDateMenu = false;
  loading = false;
  newFlightDate = null;

  @Emit()
  onSuccess(newName) {
    this.refreshPage();
  }

  async changeFlightDate() {
    this.newFlightDate = new Date(this.newFlightDate);
    let fileGeodeticService = new FileGeodeticService();
    try {
      await fileGeodeticService.partialUpdate({ id: this.file.id, flightDate: this.newFlightDate });
      // if (this.file.map2d) {
      //   await new Map2dService().partialUpdate({ id: this.file.map2d.id, flightDate: this.newFlightDate });
      // }
      // if (this.file.model3d) {
      //   await new Model3dService().partialUpdate({ id: this.file.model3d.id, flightDate: this.newFlightDate });
      // }
      // if (this.file.vr360) {
      //   await new Vr360Service().partialUpdate({ id: this.file.vr360.id, flightDate: this.newFlightDate });
      // }
      (this.$root as any).$bvToast.toast(`Đổi ngày bay thành công: ${this.newFlightDate.toISOString().substring(0, 10)}`, {
        toaster: "b-toaster-top-center",
        title: "Success",
        variant: "success",
        solid: true,
        autoHideDelay: 5000
      });
      this.onSuccess(this.newFlightDate);
    } catch (e) {
      (this.$root as any).$bvToast.toast(`Có lỗi xảy ra: ${e}`, {
        toaster: "b-toaster-top-center",
        title: "Lỗi",
        variant: "danger",
        solid: true,
        autoHideDelay: 5000
      });
    }
  }

  @Watch("dialog")
  onDialogChange(val, oldVal) {
    if (!val) {
      this.loading = false;
    } else {
      this.newFlightDate = new Date(this.file.flightDate);
      this.newFlightDate = this.newFlightDate.toISOString().substring(0, 10);
    }
  }
}
